<template>
  <div
    class="relative bg-gradient-to-br from-white to-gray-50/50 border border-gray-200 rounded-2xl p-6 cursor-pointer transition-all duration-300 hover:border-primary-300 hover:shadow-xl hover:-translate-y-2 group overflow-hidden"
    @click="$emit('select', examType)"
  >

    <div class="absolute top-0 right-0 w-32 h-32 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
      <div class="w-full h-full bg-gradient-to-br from-primary-400 to-primary-500 rounded-full transform rotate-12 scale-150"></div>
    </div>

    <div class="relative z-10">
      <div class="flex items-start justify-between mb-4">
        <div class="flex items-center space-x-4 flex-1">
          <div class="w-12 h-12 bg-gradient-to-br from-primary-100 to-primary-500 group-hover:from-primary-200 group-hover:to-primary-400 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110">
            <i class="fa-solid fa-graduation-cap text-white text-xl"></i>
          </div>

          <div class="flex-1">
            <h3 class="text-xl font-bold text-gray-900 group-hover:text-primary-600 transition-colors duration-300 mb-1">
              {{ examType.name }}
            </h3>
            <div class="w-0 h-0.5 bg-gradient-to-r from-primary-400 to-primary-600 group-hover:w-16 transition-all duration-500"></div>
          </div>
        </div>

        <div class="w-10 h-10 bg-gray-100 group-hover:bg-primary-100 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110">
          <i class="fa-solid fa-arrow-right text-gray-400 group-hover:text-emerald-500 group-hover:translate-x-1 transition-all duration-300 text-sm"></i>
        </div>
      </div>

      <div v-if="examType.description" class="mb-6">
        <p class="text-gray-600 text-sm leading-relaxed line-clamp-3 group-hover:text-gray-700 transition-colors">
          {{ examType.description }}
        </p>
      </div>

      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-2 bg-gradient-to-r from-gray-50 to-gray-100 group-hover:from-primary-50 group-hover:to-primary-50 px-4 py-2 rounded-xl transition-all duration-300">
          <div class="w-6 h-6 bg-gradient-to-br from-indigo-400 to-purple-500 rounded-lg flex items-center justify-center">
            <i class="fa-solid fa-book text-white text-xs"></i>
          </div>
          <span class="text-sm font-medium text-gray-600 group-hover:text-primary-700 transition-colors">
            Exercices disponibles
          </span>
        </div>

        <div v-if="examType.isNew" class="relative">
          <div class="bg-gradient-to-r from-orange-400 to-red-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
            NOUVEAU
          </div>
          <div class="absolute -top-1 -right-1 w-3 h-3 bg-red-400 rounded-full animate-ping"></div>
        </div>

        <div v-else-if="examType.exerciseCount" class="flex items-center space-x-1 text-emerald-600 group-hover:text-emerald-700 transition-colors">
          <span class="text-sm font-bold">{{ examType.exerciseCount }}</span>
          <i class="fa-solid fa-chevron-right text-xs"></i>
        </div>
      </div>
    </div>

    <div class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-out"></div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  examType: {
    type: Object,
    required: true
  }
})

defineEmits(['select'])
</script>

<style scoped>
/* Styles spécifiques à cette carte, s'il y en a */
</style>
